import React, { useState } from "react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";

export default function SubmitReviewForm() {
  const [form, setForm] = useState({
    quote: "",
    reviewer_name: "",
    reviewer_title: "",
    reviewer_email: "",
  });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.quote.trim() || !form.reviewer_name.trim()) return;
    setLoading(true);
    try {
      await api.post("/endorsements/submit", form);
      setDone(true);
      toast.success("Thank you — your review has been sent.");
    } catch (e) {
      toast.error(
        formatApiErrorDetail(e?.response?.data?.detail) || "Could not submit",
      );
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div
        data-testid="submit-review-thankyou"
        className="max-w-2xl mx-auto text-center py-10"
      >
        <p className="font-serif-display text-3xl italic text-ink">
          Thank you for your words.
        </p>
        <p className="mt-3 text-sm text-ink-soft">
          Barbara will read it personally — and if she shares it, it will join
          the endorsements above.
        </p>
      </div>
    );
  }

  return (
    <form
      onSubmit={submit}
      data-testid="submit-review-form"
      className="max-w-2xl mx-auto space-y-6"
    >
      <div>
        <label className="block text-xs uppercase tracking-[0.2em] text-ink-soft mb-2">
          Your words about the book
        </label>
        <textarea
          rows={4}
          required
          value={form.quote}
          onChange={set("quote")}
          data-testid="submit-review-quote"
          className="w-full bg-paper border border-rule px-4 py-3 text-base text-ink leading-relaxed outline-none focus:border-ink font-serif-display italic"
          placeholder="A few sentences from your heart…"
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-xs uppercase tracking-[0.2em] text-ink-soft mb-2">
            Your name
          </label>
          <input
            required
            value={form.reviewer_name}
            onChange={set("reviewer_name")}
            data-testid="submit-review-name"
            className="w-full bg-transparent border-b border-rule focus:border-ink py-2 text-sm text-ink outline-none"
          />
        </div>
        <div>
          <label className="block text-xs uppercase tracking-[0.2em] text-ink-soft mb-2">
            How you'd like to be described (optional)
          </label>
          <input
            value={form.reviewer_title}
            onChange={set("reviewer_title")}
            data-testid="submit-review-title"
            placeholder="Parent of two · Reader · Pastor"
            className="w-full bg-transparent border-b border-rule focus:border-ink py-2 text-sm text-ink outline-none"
          />
        </div>
      </div>
      <div>
        <label className="block text-xs uppercase tracking-[0.2em] text-ink-soft mb-2">
          Your email (optional — only Barbara sees this)
        </label>
        <input
          type="email"
          value={form.reviewer_email}
          onChange={set("reviewer_email")}
          data-testid="submit-review-email"
          className="w-full bg-transparent border-b border-rule focus:border-ink py-2 text-sm text-ink outline-none"
        />
      </div>
      <div className="pt-2">
        <button
          type="submit"
          disabled={loading || !form.quote.trim() || !form.reviewer_name.trim()}
          data-testid="submit-review-submit-btn"
          className="px-6 py-3 bg-terracotta text-paper text-xs tracking-[0.18em] uppercase hover:bg-ink transition-colors disabled:opacity-50"
        >
          {loading ? "Sending…" : "Send your review"}
        </button>
        <p className="mt-3 text-xs text-ink-soft italic">
          Reviews are read by Barbara before appearing publicly.
        </p>
      </div>
    </form>
  );
}
